import { initializeYup } from "@duosoftbg/bpo-components";
import * as yup from "yup";

export const patentSearchValidationSchema = () => {
  initializeYup(yup);
  return yup.object({});
};

export const designSearchValidationSchema = () => {
  initializeYup(yup);
  return yup.object({});
};

export const combinedSearchValidationSchema = () => {
  initializeYup(yup);
  return yup.object({});
};

export const euPatentSearchValidationSchema = () => {
  initializeYup(yup);
  return yup.object({});
};

export const spcsSearchValidationSchema = () => {
  initializeYup(yup);
  return yup.object({});
};

export const utilityModelSearchValidationSchema = () => {
  initializeYup(yup);
  return yup.object({});
};

export const plantBreedSearchValidationSchema = () => {
  initializeYup(yup);
  return yup.object({});
};
